var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSol = function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#000",
    rx: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__a)",
    d: "M30.196 16.764a.8.8 0 0 1-.526.208H11.24c-.654 0-.983-.747-.531-1.185l3.027-2.919a.77.77 0 0 1 .524-.216h18.5c.661 0 .984.754.524 1.195z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__b)",
    d: "M30.196 31.147a.8.8 0 0 1-.526.202H11.24c-.654 0-.983-.741-.531-1.18l3.027-2.926a.77.77 0 0 1 .524-.208h18.5c.661 0 .984.749.524 1.186z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__c)",
    d: "M30.196 20.05a.8.8 0 0 0-.526-.202H11.24c-.654 0-.983.74-.531 1.179l3.027 2.926a.8.8 0 0 0 .524.208h18.5c.661 0 .984-.748.524-1.185l-3.088-2.927Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__a",
    x1: 10.501,
    x2: 34.088,
    y1: 76.996,
    y2: 76.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47F8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__b",
    x1: 10.501,
    x2: 33.937,
    y1: 18.382,
    y2: 18.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__c",
    x1: 11.823,
    x2: 32.611,
    y1: 22.005,
    y2: 22.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DCDC9"
  })))));
};
export default SvgSol;